import * as LayoutActions from './layout.actions';
import { StatusMessage } from '@app/store/layout/layout.model';

export class LayoutSamplingSupplies {
    scrollTop: number;
    accordionExpanding: boolean;
}

export interface State {
    sidebarVisible: boolean;
    moveStepperFwd: boolean;
    moveStepperBwd: boolean;
    sampleTypeSelectorPopup: boolean;
    layoutSamplingSupplies: LayoutSamplingSupplies;
    isQuantityError: boolean;
    statusMessage: StatusMessage;
}

const initialState = {
    sidebarVisible: false,
    moveStepperFwd: false,
    moveStepperBwd: false,
    sampleTypeSelectorPopup: false,
    layoutSamplingSupplies: new LayoutSamplingSupplies(),
    isQuantityError: false,
    statusMessage: null
};

export function ComponentsReducer(state = initialState, action: LayoutActions.LayoutActions) {
    switch (action.type) {
    case LayoutActions.TOGGLE_SIDEBAR_VIEW:
        return {
            ...state,
            sidebarVisible: action.toggleSidebarView,
            moveStepperFwd: false,
            moveStepperBwd: false
        };
    case LayoutActions.MOVE_STEPPER_FORWARD:
        return {
            ...state,
            moveStepperFwd: true,
            moveStepperBwd: false
        };
    case LayoutActions.MOVE_STEPPER_BACKWARD:
        return {
            ...state,
            moveStepperFwd: false,
            moveStepperBwd: true
        };
    case LayoutActions.RESET_STEPPER_POSITION:
        return {
            ...state,
            moveStepperFwd: false,
            moveStepperBwd: false
        };
    case LayoutActions.TOGGLE_SAMPLE_TYPE_SELECTOR_POPUP:
        return {
            ...state,
            sampleTypeSelectorPopup: action.toggleSampleTypeSelectorPopup
        };
    case LayoutActions.SET_SAMPLING_SUPPLIES_SCROLL_TOP:
        return {
            ...state,
            layoutSamplingSupplies: { ...state.layoutSamplingSupplies, scrollTop: action.pixels }
        };
    case LayoutActions.SET_SAMPLING_SUPPLIES_ACCORDION_EXPANDING:
        return {
            ...state,
            layoutSamplingSupplies: { ...state.layoutSamplingSupplies, accordionExpanding: action.expanding }
        };
    case LayoutActions.SET_SAMPLING_SUPPLIES_QUANTITY_ERROR:
        return {
            ...state,
            isQuantityError: action.isQuantityError,
        };
    case LayoutActions.SET_STATUS_MESSAGE:
        return {
            ...state,
            statusMessage: action.statusMessage
        };
    default:
        return state;
    }
}

export const getSideBarVisible = (state: State) => state.sidebarVisible;
export const getSampleTypeSelectorPopup = (state: State) => state.sampleTypeSelectorPopup;
export const getLayoutSamplingSupplies = (state: State) => state.layoutSamplingSupplies;
export const getSamplingSuppliesQuantityError = (state: State) => state.isQuantityError;
export const getStatusMessage = (state: State) => state.statusMessage;
